import React from "react";
import PropTypes from "prop-types";

import MessageButton from "../MessageButton";
import { SAMPLE_REQUEST_BODY_HTML, canRequestSample, sampleRequestSubject } from "./requestSample";

// Per Figma, the directory cards render Request Sample as a plain underlined dark-text link (no icon,
// no button chrome) sitting inline with the card meta/price. The show page keeps a secondary outline
// button next to the primary Message button.
// Matches the Figma "Sample Link" component: 12px, medium weight, #212528, underlined.
const LINK_STYLE = {
  color: "#212528",
  textDecoration: "underline",
  fontWeight: 500,
  fontSize: 12,
  lineHeight: "17.4px",
};

// The gated "Request Sample" affordance for a product. Renders nothing unless the viewer is a
// reporter and the product offers samples. It's a MessageButton preconfigured to open the inbox
// composer with the sample-request template pre-filled (see requestSample.js), so sending it goes
// through the exact same messaging pipeline as any other message to the product's reps.
function RequestSampleButton({
  productId,
  productName,
  samplesAvailable = false,
  variant = "button", // "link" for directory cards (Figma), "button" for the product show page
  buttonLabel = "Request Sample",
  extraButtonClasses = "",
  buttonStyle = null,
}) {
  if (!canRequestSample(samplesAvailable)) return null;

  const isLink = variant === "link";

  return (
    <MessageButton
      promoEntityId={productId}
      promoEntityType="Id::PromoEntity::Product"
      openInboxThread
      composeBody={SAMPLE_REQUEST_BODY_HTML}
      composeSubject={sampleRequestSubject(productName)}
      buttonLabel={buttonLabel}
      buttonClassName={isLink ? "btn btn-link p-0 align-baseline" : "btn btn-outline-primary btn-sm"}
      extraButtonClasses={extraButtonClasses}
      iconClassName={isLink ? null : "fa-solid fa-basket-shopping"}
      buttonStyle={isLink ? { ...LINK_STYLE, ...buttonStyle } : buttonStyle}
    />
  );
}

RequestSampleButton.propTypes = {
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  productName: PropTypes.string.isRequired,
  samplesAvailable: PropTypes.bool,
  variant: PropTypes.oneOf(["button", "link"]),
  buttonLabel: PropTypes.string,
  extraButtonClasses: PropTypes.string,
  buttonStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default RequestSampleButton;
